const customFeatures = {
    namespaced: true,
    state: {
       images:null,
       features:null,
       messages:null,
       catiguries:null,
       currentCatigury:'cat_local_1',
       submissions: [],
       totalRecords: 0,
       disclaimerFlag: true,
       clientConfig:null,
       features2:null,
       showAdsRulesStatus: false
    },
    mutations: {
        UPDATE_FEATURES_ARR(state, data) {
            state.features = data
        },
        UPDATE_IMAGES_ARR(state, data) {
            state.images = data
        },
        UPDATE_MESSAGES_ARR(state, data) {
            state.messages = data
        },
        UPDATE_CATIGURIES(state, data) {
            state.catiguries = data
        },
        UPDATE_CURRENT_CATIGURY(state, data) {
            state.currentCatigury = data
        },
        UPDATE_SUBMISSIONS(state, data) {
            state.submissions = data
        },
        UPDATE_TOTAL_RECORDS(state,data) {
            state.totalRecords = data
        },
        PUSH_NEW_MORE_RECORDS(state,data) {
            state.submissions=[...state.submissions,...data]
        },
        UPDATE_LOAD_FEATURE_TRUE(state,data) {
            if(state.catiguries) {
                const arr = state.catiguries[data.catigory]
                for(let i=0;i<arr.length;i++) {
                    if(arr[i].id === data.id) {
                        arr[i].load = true
                        break
                    }
                }
            }
        },
        UPDATE_LOAD_FEATURE_TRUE_2(state,data) {
            if(state.features2) {
                const arr = state.features2
                for(let i=0;i<arr.length;i++) {
                    if(arr[i].id === data.id) {
                        arr[i].load = true
                        break
                    }
                }
            }
        },
        UPDATE_DISCLAIMER_FLAG(state, data) {
            state.disclaimerFlag = data
        },
        UPDATE_CLIENT_CONFIG(state,data) {
            state.clientConfig = data
        },
        UPDATE_FEATURES_2(state,data) {
            state.features2 = data
        },
        SHOW_ADS_RULES(state,data) {
            state.showAdsRulesStatus = data
        }
    },
    actions: {
        setFeaturesArr({ commit }, data) {
            commit('UPDATE_FEATURES_ARR', data)
        },
        setImagesArr({ commit }, data) {
            commit('UPDATE_IMAGES_ARR', data)
        },
        setMessagesArr({ commit }, data) {
            commit('UPDATE_MESSAGES_ARR', data)
        },
        setCatiguries({ commit }, data) {
            commit('UPDATE_CATIGURIES', data)
        },
        setCurrentCatigury({ commit }, data) {
            commit('UPDATE_CURRENT_CATIGURY', data)
        },
        setSubmissions({ commit }, data) {
            commit('UPDATE_SUBMISSIONS', data)
        },
        setTotalRecords({ commit }, data) {
            commit('UPDATE_TOTAL_RECORDS', data)
        },
        pushMoreRecords({ commit }, data) {
            commit('PUSH_NEW_MORE_RECORDS',data)
        },
        setLoadFeatureImg({commit},data) {
            commit('UPDATE_LOAD_FEATURE_TRUE',data)
        },
        setDisclaimerFlag({commit}, data) {
            commit('UPDATE_DISCLAIMER_FLAG',data)
        },
        setClientConfig({commit}, data) {
            commit('UPDATE_CLIENT_CONFIG',data)
        },
        setFeatures2({commit}, data) {
            commit('UPDATE_FEATURES_2',data)
        },
        setLoadFeatureImg2({commit},data) {
            commit('UPDATE_LOAD_FEATURE_TRUE_2',data)
        },
        setAdsRules({commit},data) {
            commit('SHOW_ADS_RULES',data)
        }
    }
}

export default customFeatures
